module.exports = __webpack_public_path__ + "img/43244631005985.941dc8a9.png";